import { ButtonRadioGroup } from '@/components/common/Button'
import { useIsNavigating } from '@/components/providers/NavigationProvider'
import { usePage } from '@/components/providers/PageProvider'
import { FILTER_BRACKET_EMPTY_LABEL, FILTER_BRACKET_LABELS } from '@/defs/filters'
import { SCROLL_GALLERY } from '@/defs/scroll'
import { useLinkInternal } from '@/hooks/useLinkInternal'

export const FilterInputBracket = () => {
  const { buildRelative } = useLinkInternal()
  const isNavigating = useIsNavigating()
  const { page } = usePage()

  const route = page?.route
  const bracketOptions = page?.optionsFilters?.brackets

  if (!bracketOptions) return null

  const options = [
    {
      isSelected: !route?.bracket,
      label: FILTER_BRACKET_EMPTY_LABEL.label,
      linkInternalProps: {
        href: buildRelative({ bracket: undefined }),
        scroll: SCROLL_GALLERY,
      },
      title: FILTER_BRACKET_EMPTY_LABEL.label,
    },
    ...bracketOptions.map(({ bracket, count }) => {
      const disabled = count < 1
      const popover = disabled ? <p>Not enough data!</p> : undefined
      const isSelected = bracket === route?.bracket

      return {
        disabled,
        isSelected,
        label: FILTER_BRACKET_LABELS[bracket].label,
        linkInternalProps: {
          href: buildRelative({ bracket: !isSelected ? bracket : undefined }),
          scroll: SCROLL_GALLERY,
        },
        popover,
        title: FILTER_BRACKET_LABELS[bracket].labelLong,
      }
    }),
  ]

  return <ButtonRadioGroup allowSelectedLink options={options} showLoadingMask={isNavigating} />
}
